import React, { useState } from "react";
import moment from "moment";

const fuelMarketTypes = ['MARKET','REFINERY'];

const FuelMarketsValidator = (props) => {
  const record = props.data.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) { 
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }   


  if (!error && !record.fuelMarketCode) {
    error = true;
    errorMessage = "'Fuel Market Code' is required";
  }
  if (!error && !record.fuelMarketName) {
    error = true;
    errorMessage = "'Fuel Market Name' is required";
  }
  if (!error && !record.fuelMarketType) {
    error = true;
    errorMessage = "'Fuel Market Type' is required";
  }
  if (!error && fuelMarketTypes.indexOf(record.fuelMarketType)<0) {
    error = true;
    errorMessage = "'Market Type' is invalid, please select a valid type";
  }


  if (error !== state.error || errorMessage !== state.errorMessage) {
    setTimeout(()=>{
      setState({ ...state, error, errorMessage });
      if (props.onChange) {        
        props.onChange({ error, errorMessage });
      }  
    }, 1);
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default FuelMarketsValidator;
